module.exports = __webpack_public_path__ + "static/media/birthday-left.625186e1.svg";